import trim from './trim';
import saveSettings from './saveSettings';
import users from './users';
import authentication from './authentication';

const API = {};

API.trim = trim('/api/trim/');
API.saveSettings = saveSettings('/api/save-settings/');
API.users = users('/api/users/');
API.authentication = authentication('/api/auth/');

export default API;